interface PressItem {
  outlet: string;
  title: string;
  author: string;
  date: string;
  link: string;
  country: string;
}

export const pressData: PressItem[] = [
  {
    outlet: 'RTV',
    title: 'Új nemzedék',
    author: 'RTV',
    date: '2024. augusztus 10.',
    link: 'https://media.rtv.rs/hu/uj-nemzedek/94199',
    country: 'RS',
  },
  {
    outlet: 'Magyar Szó',
    title: 'Összművészet a közösségért',
    author: 'ZS',
    date: '2024. augusztus 13.',
    link: 'https://www.magyarszo.rs/kozelet/a.313174/Osszmuveszet-a-kozossegert',
    country: 'RS',
  },
  {
    outlet: 'Hét Nap',
    title: 'Jubilált a Malomfesztivál',
    author: 'Szerda Zsófia',
    date: '2024. augusztus 15.',
    link: 'https://hetnap.rs/cikk/Jubilalt-a-Malomfesztival-49020.html',
    country: 'RS',
  },
  {
    outlet: 'koncert.hu',
    title: 'Jeti a kukoricásban, avagy így örömködtünk mi – Malomfesztivál 2024',
    author: 'mmi',
    date: '2024. augusztus 18.',
    link: 'https://www.koncert.hu/hirek/fesztival/jeti-a-kukoricasban-avagy-igy-oromkodtunk-mi--malom-fesztival-2024-13621',
    country: 'HU',
  },
  {
    outlet: 'fesztblog.hu',
    title: 'Lerántjuk a leplet! Malomfesztivál, ahonnan nincs és nem is kell kiút!',
    author: 'wetpaint',
    date: '2024. szeptember 2.',
    link: 'https://www.fesztblog.hu/2024/09/02/lerantjuk-a-leplet-malomfesztival-ahonnan-nincs-es-nem-is-kell-kiut/',
    country: 'HU',
  },
  {
    outlet: 'Telex.hu',
    title: 'Megtaláltuk a fesztivált, amibe egy pillanat alatt bele fogsz szeretni',
    author: 'Thüringer Barbara',
    date: '2024. augusztus 13.',
    link: 'https://telex.hu/after/2024/08/13/malomfesztival-riport-orom-vajdasag-szerbia',
    country: 'HU',
  },
  {
    outlet: 'HVG',
    title: 'Látjátok feleim: por – beszámoló a Malomfesztiválról',
    author: 'Feledi Márton',
    date: '2024. augusztus 14.',
    link: 'https://hvg.hu/kultura/20240814_Malomfesztival-Orom-Szerbia-beszamolo',
    country: 'HU',
  },
  {
    outlet: 'Emisija Bunt',
    title: 'BUNT ROK TURNEJA 24 / Malomfesztivál...',
    author: 'Emisija Bunt',
    date: '2024. október 5.',
    link: 'https://www.youtube.com/watch?v=AfCebXbNjnk',
    country: 'RS',
  },
  {
    outlet: 'RTV',
    title: 'Deseti Malom festival u Oromu',
    author: 'RTV',
    date: '2024. augusztus 7.',
    link: 'https://www.youtube.com/watch?v=I9eHCZ8Ey9s',
    country: 'RS',
  },
  {
    outlet: 'RTV',
    title: 'Raklap sárkány az oromi Malomfesztiválon (Jelen-lét)',
    author: 'RTV',
    date: '2024. szeptember 1.',
    link: 'https://www.youtube.com/watch?v=IXjOgFkHnYQ',
    country: 'RS',
  },
  {
    outlet: 'RTV',
    title: 'A Malomfesztivál-sztori /// F-esztelen',
    author: 'F-esztelen',
    date: '2024. augusztus 15.',
    link: 'https://www.youtube.com/watch?v=oA7uXUFvzMM',
    country: 'RS',
  },
  {
    outlet: 'Pannon RTV',
    title: 'Közel-kép - X. Malomfesztivál Oromon',
    author: 'Pannon RTV',
    date: '2024. augusztus 27.',
    link: 'https://www.youtube.com/watch?v=xLbmcxsTlxY',
    country: 'RS',
  },
  {
    outlet: 'Szabad Magyar Szó',
    title: 'Legjobb a nyár, legjobb a Malomfesztivál!',
    author: 'SZMSZ',
    date: '2024. augusztus 11.',
    link: 'https://szmsz.press/2024/08/11/legjobb-a-nyar-legjobb-a-malomfesztival/',
    country: 'RS',
  },
  {
    outlet: 'Szabad Magyar Szó',
    title: 'Tánc, irodalom, kiállítás – mindez a Malomfesztiválon',
    author: 'Seregély Orsolya',
    date: '2024. augusztus 10.',
    link: 'https://szmsz.press/2024/08/10/tanc-irodalom-kiallitas-mindez-a-malomfesztivalon/',
    country: 'RS',
  },
  {
    outlet: 'Magyar Szó',
    title: 'Orom lett a világ közepe',
    author: 'BJK',
    date: '2024. augusztus 10.',
    link: 'https://www.magyarszo.rs/vajdasag/magyarkanizsa/a.313063/Orom-lett-a-vilag-kozepe',
    country: 'RS',
  },
  {
    outlet: 'Before After',
    title: 'Bili smo na Malomfesztiválu u Oromu',
    author: 'Andrea Popov Miletić',
    date: '2024. augusztus 21.',
    link: 'https://www.beforeafter.rs/muzika/bili-smo-na-malomfesztivalu-u-oromu/',
    country: 'RS',
  },
  {
    outlet: 'Produkcijska grupa Mreža',
    title: 'Kulturno nasleđe i manifestacije na severu Banata',
    author: 'PG Mreža',
    date: '2024. szeptember 27.',
    link: 'https://mreza.rs/da-nam-nije/kulturno-nasledje-i-manifestacije-na-severu-banata/',
    country: 'RS',
  },
];
